<template>
    <div>
        <div v-if="breadcrumbs.length > 1">
            <div class="text-white text-sm">
        <span v-for="(crumb, index) in breadcrumbs" :key="index">
          <span v-if="crumb" class="cursor-pointer hover:text-gray-200 transition"
                @click="router.visit(createUrl(crumb.name))">
            <HomeIcon v-if="crumb.name === 'dashboard' || crumb.name === 'events'" class="h-4 w-4 inline mb-1"/>
            <span v-else>
              {{ crumb.label }}
            </span>
          </span>
          <span v-else>
            <ChevronRightIcon class="h-4 w-4 inline mb-1 mx-2"/>
          </span>
        </span>
            </div>
        </div>
    </div>
</template>

<script>
import navItemsMixin from "@/mixins/navItemsMixin";
import {HomeIcon} from "@heroicons/vue/24/outline";
import {ChevronRightIcon} from "@heroicons/vue/24/solid";
import { router } from "@inertiajs/vue3";

export default {
    computed: {
        breadcrumbs() {
            return this.createBreadcrumbs(route().current());
        },
        currentLink() {
            return this.findLink(this.route().current());
        },
    },

    methods: {
        createBreadcrumbs(linkName, currentBreadcrumbs = []) {
            let link = this.findLink(linkName);

            if (!link) return [];

            if (currentBreadcrumbs.length) {
                currentBreadcrumbs.unshift(link, null);
            } else {
                currentBreadcrumbs.unshift(link);
            }

            if (link.parent) {
                this.createBreadcrumbs(link.parent, currentBreadcrumbs);
            }

            return currentBreadcrumbs;
        },
        findLink(linkName) {
            return this.links.find((link) => link.name === linkName);
        },
        createUrl(linkName) {
            var url = route(linkName, route().params);

            return url.split("?")[0];
        },
    },

    mixins: [navItemsMixin],

    components: {HomeIcon, ChevronRightIcon},
    
    setup() {
        return { router };
    }
};
</script>
